<template>
    <div v-if="bloqueo==0">
        <v-row>
            <v-col cols="12" class="mt-10 text-center">
                <img src="@/assets/denegado.png" />
            </v-col>
        </v-row>
    </div>

    <div v-else>
        <v-container>
            <v-row class="mt-2">
                <v-col cols="3">
                    <v-radio-group class="mt-2" v-model="tipo" row>
                        <v-radio @click="generaTabla()" label="Producto" color="success" value="producto"></v-radio>
                        <v-radio @click="generaTabla()" label="Material" color="success" value="material"></v-radio>
                    </v-radio-group>
                </v-col>
            </v-row>
            <v-row class="mt-n7">
                <v-col cols="12">
                    <v-data-table height="350px" :loading="progress" loading-text="Cargando....." dense
                    :search="search" :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" 
                    hide-default-footer class="elevation-1 text-size col-color" @page-count="pageCount = $event">
                </v-data-table>
                </v-col>
                <v-col cols="4">
                    <v-text-field class='text-caption' v-model="search" label="Buscar Producto" dense required></v-text-field>
                </v-col>
                <v-col cols="4"></v-col>
                <v-col cols="4" class="text-end">
                    <v-btn @click="descargarXLS()" small color="teal" dark rounded block>
                        <img valign="middle" src="@/assets/csv.png" width="16px" height="20px"/>
                        <span class="ml-2 mt-1">Exportar a Excel</span>
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-dialog v-model="loading" persistent max-width="300">
            <v-card color="#fff" rounded="xl">
                <v-card-text>
                    <v-row class="mt-2">
                        <v-col cols="12" class="text-center">
                            <h3 class="mb-2">Procesando ...</h3>
                            <v-progress-linear indeterminate color="red"></v-progress-linear>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-dialog>

    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 10pt !important;
    height: 26px !important;
    /* background-color: lightyellow; */
}
.col-color >>> th {
    /* background-color: lightgrey; */
    background-color: lightblue;
}
.col-color-blue-grey >>> th {
    background-color: #c5e3e7;
}
</style>
<script>
import axios from "axios";
import exportXlsFile from 'export-from-json';
import exportFromJSON from 'export-from-json';
export default {
  name: 'Productos',
  data: () => ({
    contrato:null,
    user:null,
    apikey:null,
    loading:false,
    headers: [
      { text: 'Sku', align: 'start', sortable: true, value: 'sku' },
      { text: 'Barra', align: 'start', sortable: true, value: 'barra' },
      { text: 'Producto', align: 'start', sortable: true, value: 'producto' },
      { text: 'Variante', align: 'start', sortable: true, value: 'variante' },
      { text: 'Marca', align: 'start', sortable: true, value: 'marca' },
      { text: 'Medida', align: 'center', sortable: true, value: 'medida' },
      { text: 'Stock', align: 'center', sortable: true, value: 'Stock' },
    ],
    items: [],
    page: 1,
    pageCount: 0,
    itemsPerPage: 1000000,
    progress:false,
    tipo:'producto',
    search:'',
    bloqueo:null,
  }),
  async mounted(){
    this.loading=true;
    this.user=localStorage.getItem('user');
    this.apikey=localStorage.getItem('apiKey');
    this.contrato=localStorage.getItem('contrato');
    this.generaTabla();
    this.bloqueo = await this.myPermiso(7);
    this.loading=false;
  },
  methods:{
    async myPermiso(id){
        let result = 0;
        try {
            const headers = {
                'Content-Type' : 'application/json',
                'Authorization' : 'Token ' + this.apikey
            };
            const params = {
                contrato : this.contrato,
                user : this.user,
                id : id
            };
            const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/permission/',params,{headers});
            const datos = res.data;
            if(datos[0].existe=='si'){
                result = parseInt(datos[0].acceso);
            }
        } catch (error) {
            console.log(error)
        }
        return result
    },
    async generaTabla(){
      try {
        this.progress=true;
        this.items=[];
        const headers = {
            'Content-Type' : 'application/json',
            'Authorization' : 'Token ' + this.apikey
        };
        const params = {
            contrato : this.contrato,
            user :  this.user,
            type :  this.tipo
        };
        console.log(params);
        const res = await axios.post(process.env.VUE_APP_URL + '/api/v1/inventary/',params,{headers});
        const datos = res.data;
        if(datos[0].existe=='si'){
          datos.forEach(element => {
            this.items.push({
              sku: element.codigo,
              barra: element.barra,
              producto: element.producto,
              variante: element.variante,
              marca: element.marca,
              medida:element.medida,
              Stock: element.stock,
            })
          });
        }
        this.progress=false;          
      } catch (error) {
        console.log(error)
      }
    },
    descargarXLS(){
      this.loading=true;
      let name_file = 'Inventario';
      let tbl_data = null;
      tbl_data = this.items;
      if(tbl_data.length!=0){
          const data = tbl_data;
          const fileName = name_file;
          const exportType = exportFromJSON.types.xls;
          exportXlsFile({ data, fileName, exportType })
      } else{
          console.log('Tabla sin datos')
      }
      this.loading=false;
    },


  }
}
</script>
